import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Users from './components/Users';
import Challans from './components/Challans';
import Scholarships from './components/Scholarships';
import EditRecords from './components/EditRecords';
import AuditLogs from './components/AuditLogs';
import TeleChallan from './components/TeleChallan';
import AdmitCards from './components/AdmitCards';
import OnsiteUsers from './components/OnsiteUsers';
import OnsiteChallan from './components/OnsiteChallan';
import Layout from './components/Layout';
import Settings from './components/Settings';
import AddUser from './components/AddUser';
import EmailCampaign from './components/EmailCampaign';
import AdminManagement from './components/AdminManagement';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="add-user" element={<AddUser />} />
              <Route path="users" element={<Users />} />
              <Route path="challans" element={<Challans />} />
              <Route path="onsite-users" element={<OnsiteUsers />} />
              <Route path="onsite-challan" element={<OnsiteChallan />} />
              <Route path="scholarships" element={<Scholarships />} />
              <Route path="edit" element={<EditRecords />} />
              <Route path="edit" element={<EditRecords />} />
              <Route path="audit-logs" element={<AuditLogs />} />
              <Route path="tele-challan" element={<TeleChallan />} />
              <Route path="admit-cards" element={<AdmitCards />} />
              <Route path="emails" element={<EmailCampaign />} />
              <Route path="admin-management" element={<AdminManagement />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
